var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "snack-stack" },
    _vm._l(_vm.messages, function(m, i) {
      return _c(
        "v-card",
        {
          key: i,
          staticClass: "py-10px pl-15px pr-10px mb-10px snack-message",
          class: [m.isError ? "snack-error" : "snack-ok"]
        },
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c("v-col", { attrs: { cols: "10" } }, [
                _c("span", { staticClass: "snack-text" }, [
                  _vm._v(_vm._s(m.message))
                ])
              ]),
              _c("v-col", { attrs: { cols: "2" } }, [
                _c(
                  "div",
                  { staticClass: "snack-btn" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "link pa-0",
                        attrs: { elevation: "0", small: "" },
                        on: {
                          click: function($event) {
                            return _vm.removeMessage(m.id)
                          }
                        }
                      },
                      [_vm._v("Zavrieť")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }